import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
} from "@mui/icons-material";
import {
    Alert,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";
import {
    TableCellStyle,
    TableHeadStyled,
    TableRowStyled,
    TableContainerStyled,
} from "../../../Layouts/TableStyle";
import {
    GetInstallerAdders,
    reset,
} from "../../../Redux/InstallerSlice/InstallerSlice";

const InstallerAdders = () => {
    const dispatch = useDispatch();
    const { installer_id } = useParams();

    const { adders, isLodaing } = useSelector((state) => state.installer);
    const ADDERS = adders?.data?.Adders;

    const CallInstallerAdderMethod = async () => {
        await dispatch(GetInstallerAdders(installer_id));
        await dispatch(reset());
    };
    useEffect(() => {
        CallInstallerAdderMethod();
    }, []);
    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <TableContainerStyled>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell> # </TableCell>
                                <TableCell> Service Name </TableCell>
                                <TableCell> Adder Name </TableCell>
                                <TableCell> Price </TableCell>
                                <TableCell> Price Type </TableCell>
                                <TableCell> Is Adder </TableCell>
                                <TableCell> Availability </TableCell>
                                <TableCell> Unit </TableCell>
                                <TableCell> Status </TableCell>
                                {/* <TableCell> Action </TableCell> */}
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {ADDERS?.map((key, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>{index + 1}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.service_type
                                            ? key.service_type
                                            : " ___ "}
                                    </TableCellStyle>
                                    <TableCellStyle>{key?.name}</TableCellStyle>
                                    <TableCellStyle>
                                        {key?.pivot?.price}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.pivot?.price_type}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.pivot?.is_adder}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.pivot?.availability}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.pivot?.unit}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {parseInt(key.status) !== 0 ? (
                                            <span style={{ color: "green" }}>
                                                Active
                                            </span>
                                        ) : (
                                            <span>Inactive</span>
                                        )}
                                    </TableCellStyle>
                                    {/* <TableCellStyle>
                                    <IconButton>
                                        <Link to={"edit=" + key.id}>
                                            <Edit color="primary" />
                                        </Link>
                                    </IconButton>
                                    <IconButton
                                    // onClick={(e) => handelDeleteAdder(key)}
                                    >
                                        <Link to={"#"}>
                                            <Delete color="error" />
                                        </Link>
                                    </IconButton>

                                    {parseInt(key.status) === 0 ? (
                                        <IconButton>
                                            <CheckCircleOutline color="primary" />
                                        </IconButton>
                                    ) : (
                                        <IconButton>
                                            <DoDisturbOn color="sacundary" />
                                        </IconButton>
                                    )}
                                </TableCellStyle> */}
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>

                    {typeof ADDERS !== "undefined" && ADDERS.length === 0 && (
                        <Alert severity="error">
                            This is an error alert — check it out!
                        </Alert>
                    )}
                    {/* EDIT MODAL  */}
                    {/* <PopupModal open={edit} close={handelCloseEditRow}>
                    <EditAdder data={data} />
                </PopupModal> */}

                    {/* Update Adder Status MODAL  */}
                    {/* <PopupModal open={status} close={handelCloseStatusRow}>
                    <AdderStatusConfirm
                        data={data}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        status={setStatus}
                        close={handelCloseStatusRow}
                    />
                </PopupModal> */}

                    {/* delete modal  */}
                    {/* <DeleteModal
                    open={open}
                    close={handleClose}
                    title={data?.name}
                    onClick={DeleteRow}
                    loading={isLoading}
                /> */}
                </TableContainerStyled>
            )}
        </>
    );
};

export default InstallerAdders;
